import { render } from "./ListaModulo.vue?vue&type=template&id=531ba876&ts=true"
import script from "./ListaModulo.vue?vue&type=script&lang=ts"
export * from "./ListaModulo.vue?vue&type=script&lang=ts"

import "./ListaModulo.vue?vue&type=style&index=0&id=531ba876&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__